module.exports = __webpack_public_path__ + "13277db992f6416b569907df96db00d8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/hairbrush.png
// module id = 2045
// module chunks = 0